export const TIMEENTRY_INDEX = 'TIMEENTRY_INDEX'
export const TIMEENTRY_ADD = 'TIMEENTRY_ADD'
export const TIMEENTRY_BY_SALESLINE = 'TIMEENTRY_BY_SALESLINE'
export const TIMEENTRY_GET = 'TIMEENTRY_GET'



// WEBPACK FOOTER //
// ./src/store/actions/timeEntry.js